export default __webpack_public_path__ + "static/media/alpha_mountain.a43d472b.jpg";